import { render, staticRenderFns } from "./add-button.vue?vue&type=template&id=9bd6174e&"
import script from "./add-button.vue?vue&type=script&lang=js&"
export * from "./add-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports